const translations = {
    error: 'Error syncing quick books customers',
    success: 'QuickBooks® customers synced successfully'
};

export default translations;
